import { render, staticRenderFns } from "./TypeCriticality.vue?vue&type=template&id=12d54581&"
import script from "./TypeCriticality.vue?vue&type=script&lang=js&"
export * from "./TypeCriticality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports